<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="750px"
        append-to-body>
        <h4 slot="title" class="title-text">个人中心</h4>
        <el-descriptions :column="1" size="large" :labelStyle="labelStyle">
            <el-descriptions-item :span="2" label="姓名">{{userInfo.name||name||'--'}}</el-descriptions-item>
            <!--<el-descriptions-item label="微信绑定状态">-->
                <!--<span v-if="userInfo.is_bind_wx||is_bind_wx">已绑定</span>-->
                <!--<span v-else>-->
                    <!--未绑定-->
                     <!--<el-link type="primary" class="ml20" @click="handleBind">立即绑定</el-link>-->
                <!--</span>-->
            <!--</el-descriptions-item>-->
            <el-descriptions-item :span="2" label="手机号">
                <p>{{userInfo.mobile||mobile||'--'}}</p>
                <p class="text-color-gray mobile-tips ml10">若需修改个人信息请联系部门负责人</p>
            </el-descriptions-item>
            <el-descriptions-item label="邮箱" span="2">
                <p> {{userInfo.email||email||'--'}}</p>
                <!--<p class="text-color-gray empty-line"></p>-->
            </el-descriptions-item>
            <el-descriptions-item label="部门" span="2">
                {{userInfo.group_name_with_parent||team_name||'--'}}
            </el-descriptions-item>
            <el-descriptions-item label="角色">
                {{userInfo.role_name||roles||'--'}}
            </el-descriptions-item>
        </el-descriptions>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex'
    import API from '@/api/home';

    export default {
        name: "Profile",
        data() {
            return {
                dialogVisible: false,
                labelStyle: {
                    width: '90px',
                    textAlign: 'right',
                },
                userInfo:{
                    name:'',
                    mobile:'',
                    email:'',
                    team_name:'',
                    is_bind_wx:'',
                    roles:'',
                    role_name:'',
                },

            }
        },
        computed: {
            ...mapGetters([
                'name',
                'mobile',
                'email',
                'team_name',
                'is_bind_wx',
                'roles',
            ])
        },
        methods: {
            showModal() {
                this.dialogVisible = true;
                this.getUserCenterInfo();
            },
            handleBind() {
                this.$emit('bind-wx');
            },
            getUserCenterInfo(){
                API.getUserCenter().then(res => {
                    let resData = res.data||{};
                    // this.roleList = res.data || [];
                    this.userInfo.role_name = resData.role_name;
                    this.userInfo.group_name_with_parent = resData.group_name_with_parent;
                    this.userInfo.is_bind_wx = resData.is_bind_wx;
                    this.userInfo.email = resData.email;
                    this.userInfo.mobile = resData.mobile;
                    this.userInfo.name = resData.name;
                }, (err) => {
                    console.log('getUserCenter error', err);
                    // this.roleList = [];
                });
            }
        }
    }
</script>

<style scoped>
    .title-text {
        font-size: 14px;
    }

    .mobile-tips {
        font-size: 12px;
    }
    .empty-line{
        height: 22px;
    }
</style>
